module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-private-d38fcc64.svg";